/** EN catalog — FE-3: patients, record, caregivers, duplicates, intake. */
export const patientsEn: Record<string, string> = {
  'pt.title': 'Patients',
  'pt.sub':
    'Find, view, edit and complete records. First-call booking starts from the calendar, not here.',
  'pt.new': 'New patient',
  'pt.searchPh': 'Search file number, name or mobile',
  'pt.colPatient': 'Patient',
  'pt.colStatus': 'Status',
  'pt.colContact': 'Contact',
  'pt.colRecord': 'File no.',
  'pt.colAge': 'Age',
  'pt.colCaregiver': 'Caregiver',
  'pt.ageShort': '{n, plural, one {# year} other {# years}}',
  'pt.sortBy': 'Sort by {col}',
  'pt.sortedAsc': 'sorted ascending',
  'pt.sortedDesc': 'sorted descending',
  'pt.filterBy': 'Filter by {col}',
  'pt.apply': 'Apply',
  'pt.activeFilters': 'Active filters',
  'pt.removeFilter': 'Remove {label}',
  'pt.clearAll': 'Clear all',
  'pt.fRecord': 'File number',
  'pt.fRecordHelp': 'Exact file number; Guests have none.',
  'pt.fAgeMin': 'From age',
  'pt.fAgeMax': 'To age',
  'pt.fAgeHelp':
    'Whole years on today’s date, from the date of birth. A Guest with no date of birth on record never matches an age filter.',
  'pt.fCaregiver': 'Caregiver name',
  'pt.fPhone': 'Phone number',
  'pt.fPhoneHelp': 'Any of the record’s own numbers — contact mobile, home or additional.',
  'pt.fStatus': 'Status',
  'pt.fStatusAll': 'All',
  'pt.fStatusPatient': 'Patients',
  'pt.fStatusGuest': 'Guests',
  'pt.chipRecord': 'File {n}',
  'pt.chipAge': 'Age {min}–{max}',
  'pt.chipAgeMin': 'Age {n}+',
  'pt.chipAgeMax': 'Age up to {n}',
  'pt.chipCaregiver': 'Caregiver: {q}',
  'pt.chipPhone': 'Phone: {q}',
  'pt.chipGuest': 'Guests only',
  'pt.chipPatient': 'Patients only',
  'pt.colAutism': 'Autism',
  'pt.autismTag': 'Autism',
  'pt.fAutism': 'Autism',
  'pt.fAutismAll': 'All',
  'pt.fAutismYes': 'Identified as autistic',
  'pt.chipAutism': 'Identified as autistic',
  'pt.statePatient': 'Patient',
  'pt.stateGuest': 'Guest — first visit pending',
  'pt.stateGuestShort': 'Guest',
  'pt.stateMerged': 'Merged into another record',
  'pt.statePatientNo': 'Patient · file {n}',
  'pt.age': '{n, plural, one {# year} other {# years}} old',
  'pt.emptyTitle': 'No records yet',
  'pt.emptyBody':
    'Records are usually created from the calendar, during the first booking. New patient is here for when a record needs adding directly.',
  'pt.twoStates':
    'Guest means a bookable identity whose registration is incomplete — name and contact number only, no file number, no clinical work yet. Patient means registration was completed: the clinic system assigned the file number, and intake, assessment, packages and sessions are open.',
  'pt.phoneSearchNeedsContacts':
    'Mobile search here matches the record’s own contact number. Caregiver numbers are searched from the booking lookup, under the contacts permission.',
  'pt.matchedCaregiver':
    'Matched through a caregiver’s number — the record’s own contact number is different.',
  'pt.matchedFirstName': 'Matched by first name.',
  'pt.gate.notRegistered':
    'The clinic system refused: this record is a Guest and registration must be completed first. Nothing was created — complete the registration from the record, then try again.',
  'pt.gate.merged':
    'The clinic system refused: this identity was folded into another record. Open the surviving record and continue there.',
  'pt.errForbidden':
    'The clinic system refused: this action isn’t part of your role. Someone whose role includes patient management can do it — nothing you typed was lost.',

  'ptForm.newTitle': 'New patient',
  'ptForm.newSub':
    'One record, one form. Name and a contact number are enough to save — that is a Guest, bookable right away. Add gender, date of birth and address to register the record in the same step.',
  'ptForm.editTitle': 'Edit record',
  'ptForm.completeTitle': 'Complete registration',
  'ptForm.completeSub':
    'The registration act: gender, date of birth and address complete the record, the clinic system assigns the file number, and clinical work opens. The name stays as it was saved.',
  'ptForm.contactMobile': 'Primary contact mobile',
  'ptForm.contactMobileHelp':
    'The record’s primary contact number — for a child this is normally a parent’s or caregiver’s. Caregivers keep their own numbers on the record as well.',
  'ptForm.mobileTooShort': 'This doesn’t look like a phone number yet — enter at least 5 digits.',
  'ptForm.toRegister': 'to register',
  'ptForm.registerCta': 'Register the patient',
  'ptForm.saveGuestCta': 'Save as Guest',
  'ptForm.completeCta': 'Complete registration',
  'ptForm.registrationReady':
    'Everything the registration needs is here — saving registers the record and assigns its file number.',
  'ptForm.registrationGaps':
    'Still needed to register: {fields}. Saving without them keeps a Guest — bookable, not yet a clinical record.',
  'ptForm.registrationIncomplete':
    'The clinic system needs the full registration set before it completes. Missing:',
  'ptForm.missingField': 'Needed to register',
  'ptForm.alreadyRegistered': 'This record is already registered',
  'ptForm.alreadyRegisteredBody':
    'Registration was completed earlier and the file number is assigned. Demographics are edited from the record.',
  'ptForm.absorbOverlap':
    'The Guest and the existing record have bookings that overlap in time, so the clinic system refused to fold them together. Resolve the bookings first, then try again.',
  'ptForm.caregiverRequiredAtRegistration':
    'At this age a caregiver becomes required when the registration is completed. It can be added now or then.',
  'ptForm.first': 'First name',
  'ptForm.last': 'Last name',
  'ptForm.gender': 'Gender',
  'pt.gender.male': 'Male',
  'pt.gender.female': 'Female',
  'pt.gender.unknown': 'Unknown',
  'ptForm.genderRecorded': '{value} (as recorded)',
  'ptForm.dob': 'Date of birth',
  'ptForm.dobHelp': 'Picked in the clinic’s calendar — never free text.',
  'ptForm.address': 'Address',
  'ptForm.nationalId': 'National ID',
  'ptForm.referral': 'Referral source',
  'ptForm.referralHelp': 'Free text.',
  'ptForm.notes': 'Notes',
  'ptForm.autism': 'Identified as autistic by the clinic',
  'ptForm.autismHelp':
    'The clinic’s current identification. It can be changed later; every change is kept in the record history.',
  'ptForm.autismYes': 'Yes',
  'ptForm.autismNo': 'No',
  'ptForm.save': 'Save the record',
  'ptForm.caregiverTitle': 'Caregiver / support person',
  'ptForm.caregiverAlways':
    'Available at any age — a support person can matter at any age. Required at 18 and under, or 65 and over.',
  'ptForm.caregiverRequiredNow':
    'At this age a caregiver is required before the record can be saved.',
  'ptForm.caregiverOptionalNow': 'At this age the caregiver is optional.',
  'ptForm.caregiverSatisfied':
    'A caregiver is already on this record, so the requirement for this age is met. Fill the fields below only to add another person.',
  'ptForm.caregiverOnRecord': 'On the record: {list}.',
  'ptForm.caregiverGap': 'caregiver / support person',
  'ptForm.registrationNeedsCaregiver':
    'Everything else is here — at this age a caregiver is still needed before the record registers. Add one below.',
  'ptForm.cgName': 'Full name',
  'ptForm.cgRelationship': 'Relationship',
  'ptForm.cgOther': 'Relationship (their words)',
  'ptForm.cgMobile': 'Contact number',
  'ptForm.cgNotes': 'Notes',
  'ptForm.cgContactFirst': 'Contact this person first',
  'ptForm.cgAccompanies': 'Usually accompanies the patient',
  'ptForm.rel.mother': 'Mother',
  'ptForm.rel.father': 'Father',
  'ptForm.rel.grandparent': 'Grandparent',
  'ptForm.rel.legal_guardian': 'Legal guardian',
  'ptForm.rel.nanny_caretaker': 'Nanny / caretaker',
  'ptForm.rel.other': 'Other',
  'ptForm.caregiverRequiredError':
    'The clinic system requires at least one caregiver at this age (18 and under, or 65 and over). Nothing you typed was lost.',

  'dup.title': 'This looks like a record you already have',
  'dup.sub': 'Before a new record is created, take one look. Nothing is ever merged on its own.',
  'dup.typed': 'What you just typed',
  'dup.existing': 'The record that already exists',
  'dup.signals': 'Why this matched',
  'dup.same': 'Same person — use the existing record',
  'dup.different': 'A different person — keep both',
  'dup.absorb': 'Same person — fold this Guest into the record',
  'dup.absorbNote':
    'The Guest’s bookings move to the existing record; nothing is deleted. Recorded with your name.',
  'dup.differentNote':
    'Keeping both is recorded with your name — it is the only continuation past a flagged match.',
  'dup.needResolve':
    'Confirming a different person needs the duplicate-resolution permission. Ask a clinic administrator to finish this registration.',
  'dup.mergeNote':
    'Same person means you continue with the existing record and nothing new is created. Folding a saved Guest into its match keeps its bookings. Merging two established records is not a capability of this version.',
  'dup.askCaller': 'If unsure, simply ask the caller whether they have called before.',
  // ZOY-640: the same panel on an EDIT that changed an identity field.
  'dup.subEdit':
    'Before this change is saved, take one look. Nothing is ever merged on its own — and nothing has been saved yet.',
  'dup.typedEdit': 'What you changed this record to',
  'dup.sameEdit': 'Same person — open the existing record (this edit is not saved)',
  'dup.differentNoteEdit':
    'Keeping both saves this change and records the decision with your name — it is the only continuation past a flagged match.',
  'dup.needResolveEdit':
    'Confirming a different person needs the duplicate-resolution permission. Ask a clinic administrator to save this change.',
  'dup.mergeNoteEdit':
    'Same person means the other record is the one to use — this edit is not saved on top of it. Folding a saved Guest into its match keeps its bookings. Merging two established records is not a capability of this version.',

  'res.title': 'Who is it for?',
  'res.sub':
    'The number is the fast key during a call; a few digits or a name both work. A shared caregiver number may hold several patients — the caller is not necessarily the patient.',
  'res.searchPh': 'Caller’s mobile, a file number, or a name…',
  'res.pick': 'Book for this person',
  'res.none': 'None of them?',
  'res.moreDigits': 'Keep typing — at least five digits are needed for a number lookup.',
  'res.needRegister': 'Creating a record needs the patient-registration permission.',
  'res.signal.contact_mobile': 'this is the record’s contact number',
  'res.signal.caregiver_mobile': 'a caregiver’s number',
  'res.signal.name_dob': 'same name and birth date',
  'res.signal.national_id': 'same national ID',
  'res.newCta': 'Someone without a record',
  'res.noMatches':
    'No record matches. A first contact is saved with just a name and number — a Guest, bookable right away.',
  'res.guestTitle': 'Who is attending',
  'res.guestNameHelp': 'The person who will attend — the child, not the caller.',
  'res.guestPhone': 'Mobile / contact number',
  'res.guestPhoneHelp':
    'Carried over from the lookup — it can be a parent’s. It becomes the record’s contact number.',
  'res.guestCta': 'Save and continue',
  'res.guestNote':
    'Saved right away as a Guest: bookable, with registration still incomplete. Gender, date of birth and address are completed on the record before any clinical work.',
  'res.hostNote':
    'This component lives inside New Booking. This page is its working preview — picking opens the record.',

  'rec.attendingSince': 'Attending since {date}',
  'rec.caregiver': 'Caregiver',
  'rec.contact': 'Contact',
  'rec.gender': 'Gender',
  'rec.dob': 'Born',
  'rec.notRecorded': 'not recorded yet',
  'rec.addressNotRecorded': 'address not recorded yet',
  'rec.completeRegistration': 'Complete registration',
  'rec.guestTitle': 'Registration is incomplete',
  'rec.guestBody':
    'This is a Guest: bookings can be made, moved, cancelled or marked no-show, but intake, assessment, packages and session delivery stay closed until registration is completed and the clinic system assigns the file number.',
  'rec.guestNeedsPermission': 'Completing it needs the patient-registration permission.',
  'rec.mergedTitle': 'This identity was folded into another record',
  'rec.mergedBody':
    'It was a Guest that matched an existing patient; its bookings moved there. Nothing new is done on this page.',
  'rec.mergedOpen': 'Open the record',
  'rec.sectionsNote':
    'Each section loads on its own; if one is unavailable the rest stand while that section offers a retry.',
  'rec.retry': 'Try again',
  /* Patient workspace: summary, tabs, overview */
  'rec.tab.overview': 'Overview',
  'rec.tab.clinical': 'Clinical',
  'rec.tab.sessions': 'Sessions',
  'rec.tab.plans': 'Packages & Payments',
  'rec.tab.details': 'Details',
  'rec.tabsLabel': 'Patient record',
  'rec.sum.file': 'File no.',
  'rec.sum.age': 'Age',
  'rec.sum.dob': 'Date of birth',
  'rec.sum.gender': 'Gender',
  'rec.sum.contact': 'Contact',
  'rec.sum.caregiver': 'Primary caregiver',
  'rec.sum.since': 'Attending since',
  'rec.sum.stage': 'Care stage',
  'rec.sum.guestFile': 'Assigned at registration',
  'rec.ov.nextTitle': 'Where this patient is',
  'rec.ov.nextSub': 'The care stage from the clinic system, and the next thing to do.',
  'rec.ov.upcomingTitle': 'Next appointment',
  'rec.ov.noUpcoming': 'Nothing scheduled.',
  'rec.ov.lastDelivered': 'Last delivered {date}',
  'rec.ov.clinicalTitle': 'Clinical status',
  'rec.ov.intakeNone': 'No intake yet',
  'rec.ov.assessmentNone': 'No assessment yet',
  'rec.ov.assessmentSigned': 'Signed {date}',
  'rec.ov.instruments':
    '{n, plural, =0 {No instrument} one {# instrument administration} other {# instrument administrations}}',
  'rec.ov.plansTitle': 'Packages',
  'rec.ov.noPackages': 'No package yet.',
  'rec.ov.attentionTitle': 'Needs attention',
  'rec.ov.unpaid':
    '{n, plural, one {# delivered session is waiting for its payment to be recorded} other {# delivered sessions are waiting for their payment to be recorded}}',
  'rec.ov.stalled': 'Care looks stalled — no recent delivery against an open package.',
  'rec.ov.nothingAttention': 'Nothing waiting.',
  'rec.ov.open': 'Open',
  'rec.ov.caregiverTitle': 'Contact',
  'rec.ses.title': 'Appointments and sessions',
  'rec.ses.sub':
    'Every booking on this record with what became of it; a delivered session opens its own page.',
  'rec.ses.filter.upcoming': 'Upcoming',
  'rec.ses.filter.all': 'All',
  'rec.ses.filter.delivered': 'Delivered',
  'rec.ses.colWhen': 'When',
  'rec.ses.colWhat': 'Session',
  'rec.ses.colState': 'Outcome',
  'rec.ses.empty': 'No appointments on this record yet.',
  'rec.ses.emptyUpcoming': 'Nothing upcoming.',
  'rec.ses.sessionN': 'session {n}',
  'rec.ses.voided': 'Voided',
  'rec.ses.colDay': 'Day',
  'rec.ses.routineTitle': 'Regular schedule',
  'rec.ses.routineSub': 'Read off the appointments of the last eight weeks and those ahead.',
  'rec.ses.routineDay': '{day}s',
  'rec.ses.routineWhen': '{weekdays} {time}',
  // ZOY-685/686: this patient's group-session history — independent occurrences.
  'rec.grp.title': 'Group sessions',
  'rec.grp.sub':
    'Every group session this patient took part in. Each one is its own occurrence with its own attendees; the group report is shared by everyone who attended it.',
  'rec.grp.empty': 'No group sessions on this record.',
  'rec.grp.colReport': 'Group report',
  'rec.grp.reportView': 'View report',
  'rec.grp.reportWrite': 'Write the report',
  'rec.grp.reportNone': 'No report yet',
  'rec.grp.open': 'Open session',
  'rec.plan.progress':
    '{delivered} of {planned} delivered · {scheduled} scheduled · {remaining} to schedule',
  'rec.plan.overbooked':
    'Scheduled beyond the plan by {n} — sessions past the plan are delivered at the catalogue price.',
  'rec.plan.overDelivered': 'Delivered beyond the plan by {n} — at the catalogue price.',
  'rec.plan.owed': '{amount} owed',
  'rec.plan.credit': '{amount} credit',
  'rec.plan.settled': 'Settled',
  'rec.plan.stillOwed': '{amount} still owed on this package',
  'rec.plan.paymentsSub':
    'From the patient account: what is owed, what is held as credit, and the net — the clinic system’s figures.',
  'rec.det.registration': 'Registration',
  'rec.det.registeredOn': 'Registered {date}',
  'rec.det.registeredBy': 'by {who}',
  'rec.det.createdOn': 'Record created {date}',
  'rec.det.nationalId': 'National ID',
  'rec.det.address': 'Address',
  'rec.det.referral': 'Referral source',
  'rec.sectionFailed': 'This section couldn’t load. Everything else on the record stands.',
  'rec.demographics': 'Demographics',
  'rec.caregivers': 'Caregivers',
  'rec.historyIntake': 'History & intake',
  'rec.adminHistory': 'Record history',
  'rec.adminHistoryBody':
    'Recorded changes to this record — identity, caregivers added, removed or corrected, intake, packages, sessions and instruments — with prior values. Assessment amendments are listed on each assessment.',
  'rec.noAssigned':
    'There is no assigned therapist: the patient attends the clinic, and each session carries its own practitioner.',
  'rec.editCta': 'View and edit',
  'rec.laterPhase': 'Designed in {phase}',
  'rec.assessments': 'Assessments',
  'rec.packages': 'Packages',
  'rec.bookings': 'Bookings',
  'rec.sessions': 'Delivered sessions',
  'rec.journey': 'Journey',
  'rec.payments': 'Payment facts',
  'rec.addCaregiver': 'Add caregiver',
  'rec.cgRefused': 'The clinic system refused this change — nothing you typed was lost.',
  'rec.cgPrimary': 'Primary contact',
  'rec.cgMakePrimary': 'Make primary contact',
  'rec.removeCaregiverTitle': 'Remove this caregiver from the record?',
  'rec.removeCaregiverBody':
    'The entry is removed from use but stays in the record’s history — nothing is deleted.',
  'rec.historyEmpty': 'No corrections yet — the record stands as first written.',
  'rec.hSet': 'set to {value}',
  'rec.hChanged': 'was {from} — now {to}',
  'rec.hf.gender': 'Gender',
  'rec.hf.dateOfBirth': 'Date of birth',
  'rec.hf.address': 'Address',
  'rec.hf.recordNumber': 'File number',
  'rec.hf.firstName': 'First name',
  'rec.hf.lastName': 'Last name',
  'rec.hf.contactMobile': 'Primary contact mobile',
  'rec.hf.nationalId': 'National ID',
  'rec.hf.absorbedPatientId': 'A Guest record was absorbed into this one',
  'rec.hf.autismIdentified': 'Autism identification',
  'rec.hv.autismYes': 'identified as autistic',
  'rec.hv.autismNo': 'not identified as autistic',
  'rec.hc.added': 'Companion added',
  'rec.hc.removed': 'Companion removed',
  'rec.hc.unreadable': 'A companion (details not readable)',
  'rec.hc.f.name': 'Companion name',
  'rec.hc.f.relationship': 'Companion relationship',
  'rec.hc.f.relationshipOther': 'Companion relationship (their words)',
  'rec.hc.f.mobile': 'Companion contact number',
  'rec.hc.f.other': 'Companion detail',
  'rec.hf.differentPersonConfirmed': 'Duplicate review',
  'rec.hv.dupDecision':
    'Confirmed as a different person from {n, plural, one {# similar record} other {# similar records}} — both kept.',
  'rec.hv.dupSignals': 'Matched on: {signals}.',
  'rec.hv.dupUnreadable': 'A duplicate-review decision (details not readable)',
  'rec.hv.sig.contact_mobile': 'the same contact number',
  'rec.hv.sig.caregiver_mobile': 'a caregiver’s number',
  'rec.hv.sig.name_dob': 'the same name and birth date',
  'rec.hv.sig.national_id': 'the same national ID',

  'path.title': 'The first visit',
  'path.sub': 'What is done and what remains — nothing hospital-like.',
  'path.registration': 'Registration',
  'path.registrationDone': 'Done',
  'path.registrationDoneOn': 'Done — {date}',
  'path.registrationPending': 'Not completed yet — bookable, not a clinical record',
  'path.needsRegistration': 'Opens once registration is completed',
  'path.intake': 'Intake',
  'path.intakeOptional': 'Optional — skipping it blocks nothing',
  'path.intakeInProgress': 'In progress',
  'path.intakeDone': 'Done',
  'path.intakeStart': 'Start intake',
  'path.assessment': 'Initial assessment',
  'path.assessmentDone': 'Done — {date}',
  'path.assessmentPending':
    'An Initial Assessment is recommended — booked from the calendar; a package can also be created without it.',
  'path.package': 'Package and ongoing sessions',
  'path.packageGate':
    'No package yet — an Initial Assessment is recommended, but a package can be created without it.',
  'path.packageOpen': 'No package yet — one can be created.',

  'intake.title': 'Intake',
  'intake.sub':
    'A short, friendly conversation, not a form. Optional — it never gates the assessment, diagnoses nothing, and decides no package.',
  'intake.start': 'Start an intake',
  'intake.mode': 'How it is captured',
  'intake.mode.self_entry': 'Self-entered (clinic-facilitated)',
  'intake.mode.staff_assisted': 'Staff-assisted',
  'intake.status.in_progress': 'In progress',
  'intake.status.completed': 'Completed',
  'intake.contextGoals': 'What the family hopes for',
  'intake.contextGoalsHelp': 'In their own words.',
  'intake.notes': 'Notes',
  'intake.complaints': 'Concerns',
  'intake.complaintDesc': 'Concern',
  'intake.severity': 'Severity',
  'intake.duration': 'Duration',
  'intake.history': 'Relevant history',
  'intake.historyItem': 'History item',
  'intake.detail': 'Detail',
  'intake.medications': 'Medications',
  'intake.medication': 'Medication',
  'intake.dosage': 'Dosage',
  'intake.frequency': 'Frequency',
  'intake.medStatus': 'Status',
  'intake.selfReported': 'Self-reported',
  'intake.staffRecorded': 'Staff-recorded',
  'intake.addRow': 'Add',
  'intake.removeTitle': 'Withdraw this row?',
  'intake.removeBody':
    'The row leaves the intake, and the record keeps who withdrew it and when — nothing is deleted. Rows added by mistake are withdrawn this way.',
  'intake.errCompleted':
    'This intake was already marked completed by someone else — the page has been refreshed. Its content can still be corrected.',
  'intake.errGone':
    'That row was already withdrawn by someone else — the list has been refreshed. Nothing else changed.',
  'intake.errDupHistory':
    'That history item is already selected on this intake — edit the existing row instead of adding it again.',
  'intake.errRefused':
    'The clinic system refused this change — nothing you typed was lost. Check the fields and try again.',
  'intake.completeCta': 'Mark intake completed',
  'intake.completeTitle': 'Complete this intake?',
  'intake.completeBody':
    'Completion is an explicit act. Nothing inside was mandatory, and the self-reported originals stay reconstructible.',
  'intake.completedNote':
    'Completed — the assessment references it live, never as a copy. Corrections stay possible; every change is recorded with who and when.',
  'intake.none': 'No intake yet. Skipping it blocks nothing.',
  'intake.open': 'Open',
  /* ── Intake redesign (ZOY-574) ─────────────────────────────────────────── */
  'intake.clinicalTitle': 'Perinatal history & clinical reports',
  'intake.clinicalSub':
    'Birth-period facts and report summaries for this intake. Date of birth and referral source belong to the patient record and are shown here for context.',
  'intake.dob': 'Date of birth',
  'intake.dobEstimated': 'estimated',
  'intake.referralSource': 'Referral source',
  'intake.patientOwnedNote': 'Edited on the patient record, not here.',
  'intake.apgar': 'Apgar score',
  'intake.apgarHelp': 'As recorded — e.g. 8/9.',
  'intake.nicuAdmitted': 'NICU admission',
  'intake.nicuDuration': 'Length of NICU stay',
  'intake.nicuDurationValue': 'Duration',
  'intake.nicuDurationUnit': 'Unit',
  'intake.nicuUnit.days': 'days',
  'intake.nicuUnit.weeks': 'weeks',
  'intake.nicuUnit.months': 'months',
  'intake.nicuPairErr': 'Give both the duration and its unit, or neither.',
  'intake.nicuValueErr': 'Enter a whole number.',
  'intake.nicuDetails': 'NICU details',
  'intake.jaundice': 'Neonatal jaundice',
  'intake.jaundiceDetails': 'Jaundice details',
  'intake.eegReport': 'EEG report',
  'intake.brainImagingReport': 'Brain imaging report',
  'intake.metabolicLabReport': 'Metabolic lab report',
  'intake.brainInjuryHistory': 'Brain injury history',
  'intake.surgeryHistory': 'Surgery history',
  'intake.reportHelp': 'Descriptive free text — what the report says, in the clinician’s words.',
  'intake.yes': 'Yes',
  'intake.no': 'No',
  'intake.unanswered': 'Unanswered',
  'intake.clearAnswer': 'Mark as unanswered',
  'intake.saved': 'Saved.',
  /* complaints (ZOY-571) */
  'intake.complaintCategory': 'Category',
  'intake.complaintItem': 'Complaint',
  'intake.complaintOtherText': 'Describe the complaint',
  'intake.complaintOtherHelp': 'Required for “Other” — say what the concern is.',
  'intake.pickCategoryFirst': 'Choose a category first.',
  'intake.sev.mild': 'Mild',
  'intake.sev.moderate': 'Moderate',
  'intake.sev.severe': 'Severe',
  'intake.notesRow': 'Notes',
  'intake.cc.speech_language': 'Speech & language',
  'intake.cc.social_communication': 'Social communication',
  'intake.cc.behaviour_attention': 'Behaviour & attention',
  'intake.cc.motor': 'Motor',
  'intake.cc.sensory': 'Sensory',
  'intake.cc.feeding_sleep': 'Feeding & sleep',
  'intake.cc.learning': 'Learning',
  'intake.cc.other': 'Other',
  'intake.legacyRow': 'Recorded before the catalogue',
  'intake.legacySeverity': 'Recorded as: {value}',
  /* history (ZOY-570) */
  'intake.hs.medical_condition': 'Medical conditions',
  'intake.hs.developmental_history': 'Developmental / birth history',
  'intake.otherHistory': 'Other history',
  'intake.otherHistoryNote':
    'Recorded before history was split into sections — shown exactly as stored.',
  'intake.historyOtherHelp': 'Required for “Other” — say what it is.',
  /* medications (ZOY-572) */
  'intake.medSource': 'Source',
  'intake.medFromList': 'From the medication list',
  'intake.medOther': 'Not in the list',
  'intake.medOtherName': 'Medication name',
  'intake.medCategory': 'Category',
  'intake.medAllCategories': 'All categories',
  'intake.medSearch': 'Search medications',
  'intake.medSearchHelp': 'Type part of the brand or generic name.',
  'intake.medSearchHint': 'Search, or pick a category, to see medications.',
  'intake.medNoResults': 'Nothing matches.',
  'intake.medPicked': 'Selected',
  'intake.medChange': 'Change',
  'intake.timeframe': 'Timeframe',
  'intake.tf.current': 'Current',
  'intake.tf.historical': 'Past',
  'intake.tf.unspecified': 'Unspecified',
  'intake.timeframeNeeded': 'Choose current or past.',
  'intake.medSourceNeeded': 'Pick a medication from the list, or enter its name.',
  'intake.reason': 'Reason',
  'intake.prescriber': 'Prescriber',
  'intake.startOn': 'Started',
  'intake.endOn': 'Ended',
  'intake.year': 'Year',
  'intake.month': 'Month',
  'intake.dateHelp': 'Approximate — the year, or the year and month.',
  'intake.endOnlyPast': 'An end date applies only to a past medication.',
  'intake.legacyStatus': 'Recorded status: {value}',
  /* typed refusals */
  'intake.errOtherDetail': 'For “Other”, the text is required.',
  'intake.errDescNotAllowed':
    'A catalogue item carries its own name — free text is only for “Other”.',
  'intake.errUnavailable':
    'That item is no longer available for new entries. Existing records keep it — pick another.',
  'intake.errMedDate': 'That is not a real calendar date.',
  'intake.errMedEnd': 'Only a past medication can have an end date.',
  'intake.errMedOrder': 'The end must not be before the start.',
  'intake.errMedSource': 'Give exactly one: a medication from the list, or a name.',
  /* medication categories — the seeded master-list drill-down (ZOY-572) */
  'intake.mc.anticonvulsant': 'Anticonvulsants',
  'intake.mc.antipsychotic': 'Antipsychotics',
  'intake.mc.antidepressant': 'Antidepressants',
  'intake.mc.stimulant': 'Stimulants (ADHD)',
  'intake.mc.non_stimulant_adhd': 'Non-stimulant ADHD',
  'intake.mc.anxiolytic_sedative': 'Anxiolytics & sedatives',
  'intake.mc.gastrointestinal': 'Gastrointestinal',
  'intake.mc.allergy_respiratory': 'Allergy & respiratory',
  'intake.mc.antibiotic': 'Antibiotics',
  'intake.mc.supplement': 'Supplements',
  'intake.mc.probiotic': 'Probiotics',
  'intake.mc.other': 'Other',

  /* ── Intake attachments (ZOY-705) ─────────────────────────────────────── */
  'intake.att.title': 'Attachments',
  'intake.att.count': '{n, number} of {max, number}',
  'intake.att.limits':
    'PDF, PNG, JPEG or WebP · up to {mb} MB each · at most {max, number} per intake. Each file can carry its own description once uploaded.',
  'intake.att.add': 'Add files',
  'intake.att.full':
    'This intake holds the maximum number of attachments — remove one to add another.',
  'intake.att.skipped':
    '{n, plural, one {# file was not added} other {# files were not added}} — an intake holds at most {max, number} attachments.',
  'intake.att.empty': 'No attachments yet.',
  'intake.att.unnamed': 'Untitled file',
  'intake.att.addedBy': 'added by {name}',
  'intake.att.kind.pdf': 'PDF',
  'intake.att.kind.png': 'PNG',
  'intake.att.kind.jpeg': 'JPEG',
  'intake.att.kind.webp': 'WebP',
  'intake.att.kind.file': 'File',
  'intake.att.open': 'Open',
  'intake.att.describe': 'Add description',
  'intake.att.editDesc': 'Edit description',
  'intake.att.noDesc': 'No description.',
  'intake.att.descLabel': 'Description',
  'intake.att.descHelp': 'Optional — what this document is, at most {max, number} characters.',
  'intake.att.descTooLong': 'Too long — shorten the description.',
  'intake.att.descSave': 'Save description',
  'intake.att.removeTitle': 'Remove this attachment?',
  'intake.att.removeBody':
    '“{name}” leaves the intake, and the record keeps who removed it and when. The file itself is deleted afterwards.',
  'intake.att.removeReason': 'Reason (optional)',
  'intake.att.uploadingChip': 'Uploading',
  'intake.att.failedChip': 'Not added',
  'intake.att.queued': 'Waiting…',
  'intake.att.declaring': 'Preparing…',
  'intake.att.uploading': 'Uploading… {pct, number}%',
  'intake.att.completing': 'Finishing…',
  'intake.att.retry': 'Try again',
  'intake.att.dismiss': 'Dismiss',
  'intake.att.errType': 'Only PDF, PNG, JPEG or WebP files can be attached.',
  'intake.att.errSize': 'This file is larger than the 10 MB limit.',
  'intake.att.errLimit': 'This intake already holds the maximum number of attachments.',
  'intake.att.errContent': 'The file’s content is not an accepted type, so it was not kept.',
  'intake.att.errState':
    'This attachment is no longer in a state that allows that — the page has been refreshed.',
  'intake.att.errGone':
    'That attachment was already removed by someone else — the list has been refreshed.',
  'intake.att.errStorage': 'Storage could not be reached just now — try again in a moment.',
  'intake.att.errUpload': 'The file could not be sent to storage — try again.',
  'intake.att.cardCount': '{n, plural, one {# attachment} other {# attachments}}',

  /* ── Patient phones (ZOY-705) ─────────────────────────────────────────── */
  'ptForm.homePhone': 'Home phone',
  'ptForm.altPhone': 'Additional phone',
  'ptForm.phoneOptionalHelp': 'Optional — another way to reach the family.',
  'ptForm.mobileNotCanonical':
    'This number could not be read as a phone number — enter it with its area code, e.g. 021… or 0912….',
  'rec.sum.homePhone': 'Home phone',
  'rec.sum.altPhone': 'Additional phone',
  'res.signal.home_phone': 'Home phone',
  'res.signal.alt_phone': 'Additional phone',
  'res.signal.other': 'matched this record',
  'pt.fPhoneKind.contactMobile': 'contact mobile',
  'pt.fPhoneKind.homePhone': 'home phone',
  'pt.fPhoneKind.altPhone': 'additional phone',
  'pt.chipPhoneVia': 'Phone: {q} · matched the {kind}',
};
